import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Alert, Button, Typography } from "@mui/material";
import React, { useRef, useState } from "react";
import "./MobileWizard.scss";

interface UploadPhotoProps {
  buttonLabel: string;
  imgBlobLink: string;
  setUploadedImage: React.Dispatch<React.SetStateAction<File | null>>;
  uploadedImage: File | null;
  isDesktop?: boolean;
}

const UploadPhoto: React.FC<UploadPhotoProps> = ({
  buttonLabel,
  imgBlobLink: _imgBlobLink,
  setUploadedImage,
  uploadedImage,
  isDesktop
}) => {
  const ref = useRef<HTMLInputElement>(null);
  const [fileName, setFileName] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const uploadFile = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const img = e.target.files?.[0];
    e.target.value = "";
    setErrorMessage("");

    if (img && validateFileType(img.name)) {
      setUploadedImage(img);
      setFileName(img.name);
    }
  };

  const validateFileType = (fileName: string) => {
    var extFile = getExt(fileName);
    if (extFile === "jpg" || extFile === "jpeg" || extFile === "png") {
      return true;
    } else {
      setErrorMessage("Only JPG/JPEG/PNG files are allowed.");
      return false;
    }
  };

  const getExt = (fileName: string) => {
    var idxDot = fileName.lastIndexOf(".") + 1;
    return fileName.substr(idxDot, fileName.length).toLowerCase();
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        // alignItems: "center",
        width: isDesktop ? '30%' : '100%',
        // justifyContent: "center",
      }}
    >
      {/* <img src={uploadedImage ? uploadedImage : ""} alt="asfsafas" /> */}
      {/* <Avatar
        component={uploadedImage ? uploadedImage.name : ""}
        sx={{
          height: "175px",
          width: "175px",
          border: "#FAFAFA solid 2px",
          marginBottom: "15px",
        }}
        alt="League Avatar"
      ></Avatar> */}
      <>
        <UploadButton
          buttonLabel={fileName ? "Replace league photo" : buttonLabel}
          onClick={() => ref.current?.click()}
        />
        <input
          id="filePickerLeague"
          className="wizardUpload__input"
          type="file"
          onChange={uploadFile}
          accept="image/*"
          ref={ref}
        />
      </>

      {fileName && (
        <Typography sx={{ mt: 1 }}>
          Selected image: {fileName}
        </Typography>
      )}

      {errorMessage && (
        <Alert severity="error" sx={{ mt: 1 }}>
          {errorMessage} Please choose another file and try again.
        </Alert>
      )}
    </div>
  );
};

export default UploadPhoto;

export const UploadButton: React.FC<UploadButtonProps> = ({
  onClick,
  buttonLabel,
}) => {
  return (
    <Button
      variant="contained"
      color="primary"
      startIcon={<CloudUploadIcon />}
      onClick={() => onClick()}
    >
      {buttonLabel}
    </Button>
  );
};

interface UploadButtonProps {
  onClick: () => void;
  buttonLabel: string;
}
